/** WStudio mappable-attribute catalog (WSRPDM-0027, handoff §D1). */
import { request } from '../client';

export interface WStudioAttribute {
  id: string;
  label: string;
  valueType: string;
  source: 'USER_ATTRIBUTE' | 'SALES_LOOKUP';
  suggestedKey: string;
}

export interface WStudioAttributesResponse {
  attributes: WStudioAttribute[];
}

export async function getAttributes(): Promise<WStudioAttributesResponse> {
  return request<WStudioAttributesResponse>('GET', '/admin/platform/wstudio/attributes');
}
